import React from 'react';
import PropTypes from 'prop-types';

import { Collapse, TableCell, TableRow } from '@mui/material';

import OnEditIcon from '../../../icons/OnEditIcon';
import { reverseFormatDate } from '../../../utils/dateFunctions';

import FormRowDetails from './FormRowDetails';

import classes from '../../../commonStyles/tables.module.css';

const dropdownStyles = {
    paddingBottom: 0,
    paddingTop: 0,
    paddingLeft: 0,
    paddingRight: 0,
    borderTop: 'none',
    borderBottom: 'none'
};

const FormRow = ({
    row,
    participantsAdviser,
    hasAuthRoles,
    isSuperUser,
    toggleDropdown,
    openId,
    showForm,
    editForm,
    onEdit,
    isDisabled
}) => {
    // EVENT HANDLERS
    const onToggleDropdown = () => {
        toggleDropdown(openId === row.id ? null : row.id);
    };

    // RENDER
    return (
        <>
            <TableRow hover className={`${classes.tableRowStripes} ${classes.canOpen}`}>
                <TableCell onClick={onToggleDropdown}>{row.name}</TableCell>
                <TableCell onClick={onToggleDropdown}>{row.createdEmailAddress}</TableCell>
                <TableCell onClick={onToggleDropdown}>{row.authorisedEmailAddress}</TableCell>
                <TableCell onClick={onToggleDropdown}>
                    {reverseFormatDate(row.lastUpdated)}
                </TableCell>
                <TableCell onClick={onToggleDropdown}>{row.status}</TableCell>
                <TableCell align="right">
                    {(row.status.toLowerCase() === 'open' ||
                        (row.status.toLowerCase() === 'withdrawn' && hasAuthRoles) ||
                        isSuperUser) && (
                        <OnEditIcon
                            onEdit={(e) => onEdit(e, row)}
                            active={!showForm && !editForm && !isDisabled}
                            tooltip={
                                row.status.toLowerCase() !== 'authorised'
                                    ? 'Edit form'
                                    : 'SUPERUSER can edit authorised forms'
                            }
                        />
                    )}
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={dropdownStyles} colSpan={8}>
                    <Collapse in={openId === row.id} timeout="auto" unmountOnExit>
                        <FormRowDetails
                            row={row}
                            participantsAdviser={participantsAdviser}
                            isDisabled={isDisabled}
                            onClose={() => toggleDropdown(null)}
                        />
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
};

FormRow.propTypes = {
    row: PropTypes.object,
    participantsAdviser: PropTypes.object,
    hasAuthRoles: PropTypes.bool,
    isSuperUser: PropTypes.bool,
    toggleDropdown: PropTypes.func,
    openId: PropTypes.string,
    showForm: PropTypes.bool,
    editForm: PropTypes.bool,
    onEdit: PropTypes.func,
    isDisabled: PropTypes.bool.isRequired
};

export default FormRow;
